export const CycleMode = {
  ANNIVERSARY: 'Anniversary',
  CALENDAR_YEAR: 'CalendarYear',
  FIXED_DAYS: 'FixedDays',
};

export const CYCLE_MODE_OPTIONS = [
  { value: CycleMode.ANNIVERSARY, label: 'Anniversary' },
  { value: CycleMode.CALENDAR_YEAR, label: 'Calendar Year' },
  { value: CycleMode.FIXED_DAYS, label: 'Fixed Days' },
];

export const CYCLE_MODE_HELPER_TEXT = {
  [CycleMode.ANNIVERSARY]: 'Anniversary: rolling 365 days from each approval date.',
  [CycleMode.CALENDAR_YEAR]: 'Calendar Year: every cycle ends on December 31.',
  [CycleMode.FIXED_DAYS]: 'Fixed Days: every cycle is the same configurable number of days.',
};

export const FIXED_DAYS_DEFAULT = 365;
export const FIXED_DAYS_MIN = 30;

export const RENEWAL_WINDOW_DEFAULT = 0;
export const RENEWAL_WINDOW_MIN = 0;
export const RENEWAL_WINDOW_MAX = 365;

export const RENEWAL_WINDOW_HELPER_TEXT =
  'How many days before a TPO\u2019s certification expires they can begin a new cycle. 0 = strict, no overlap.';

export const REMINDERS_EXAMPLE = '30, 14, 7';

export const REMINDERS_HELPER_TEXT = `Comma-separated days before expiry, strictly decreasing (e.g. ${REMINDERS_EXAMPLE}).`;

export const REMINDERS_PLACEHOLDER = `e.g. ${REMINDERS_EXAMPLE}`;

export const REMINDERS_TOGGLE_LABEL = 'Send certification renewal reminders';

export const FIXED_DAYS_INPUT_PROPS = { min: FIXED_DAYS_MIN };

export const RENEWAL_WINDOW_INPUT_PROPS = {
  min: RENEWAL_WINDOW_MIN,
  max: RENEWAL_WINDOW_MAX,
};

export const DEFAULT_CERTIFICATION_CYCLE = {
  cycleMode: CycleMode.ANNIVERSARY,
  cycleFixedDays: FIXED_DAYS_DEFAULT,
  recertificationRenewalWindowDays: RENEWAL_WINDOW_DEFAULT,
  remindersEnabled: false,
  remindersDaysBeforeExpiry: '',
};

export const RemindersInvalidReason = {
  EMPTY: 'empty',
  NON_POSITIVE_INTEGER: 'non_positive_integer',
  NOT_STRICTLY_DECREASING: 'not_strictly_decreasing',
};

export const REMINDERS_INVALID_MESSAGES = {
  [RemindersInvalidReason.EMPTY]: 'Enter at least one days-before-expiry value.',
  [RemindersInvalidReason.NON_POSITIVE_INTEGER]: 'Each value must be a positive integer.',
  [RemindersInvalidReason.NOT_STRICTLY_DECREASING]: `Values must be strictly decreasing (e.g. ${REMINDERS_EXAMPLE}).`,
};

export const REMINDERS_INVALID_FALLBACK_MESSAGE = `Enter strictly decreasing positive integers (e.g. ${REMINDERS_EXAMPLE}).`;
